import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams, useRouteMatch } from 'react-router-dom';

import { RootState } from '../../../../core/state/state';
import { getProjects } from '../../../../core/state/project/asyncActions';
import { AuthStatus } from '../../../../core/enums/AuthStatus';
import { COMPANY_CONTACTS, HOME_ROUTE, PROFILE } from '../../../../core/constants/routes';
import { isAzureAccount } from '../../../../core/utils/isAzureAccount';
import Image from '../../../../components/image/Image';
import logo from '../../../../../img/logo.svg';
import Icon from '../../../../components/icon/Icon';

interface Props {
  isMenuOpen: boolean;
  handleMenu: () => void;
}

const HeaderMobileScreen: React.FC<Props> = ({ isMenuOpen, handleMenu }) => {
  const status = useSelector((state: RootState) => state.auth.status);
  const dispatch = useDispatch();
  const isAuthenticated = status === AuthStatus.Authenticated;
  const { path } = useRouteMatch<{ path: string }>();
  const { projectId } = useParams<{ projectId: string; userId: string }>();

  const subcontractorProjectId = useSelector((state: RootState) => state.user.userInfo?.projectID);

  const logoRedirectionPath = () => {
    switch (path) {
      case PROFILE:
      case COMPANY_CONTACTS:
        return `/projects/${subcontractorProjectId}/bookings`;
      default:
        return isAzureAccount ? HOME_ROUTE : `/projects/${projectId}/bookings`;
    }
  };

  React.useEffect(() => {
    dispatch(getProjects(true));
  }, [projectId, dispatch]);

  return (
    <div className="header">
      <div className="d-flex align-items-center">
        <Link to={logoRedirectionPath()}>
          <Image className="header__logo mr-0" src={logo} alt="logo" />
        </Link>
      </div>
      {isAuthenticated && (
        <Icon onClick={() => handleMenu()} className="header__mobile-menu-icon" icon={`${isMenuOpen ? 'x' : 'list'}`} svg size="full-size" />
      )}
    </div>
  );
};

export default HeaderMobileScreen;
